<template>
  <v-card style="margin: 10px" min-width="350px" class="d-flex flex-column">

    <!-- title -->
    <v-container text-center class="pa-0">
      <v-row>
        <v-col>
          <h2>Kommentar</h2>
        </v-col>
      </v-row>
    </v-container>

    <!-- Coment Data -->
    <v-container class="pa-0" style="margin-left: 30px; margin-right: 30px">
      <v-col>
        <v-row>Author: {{ pendingVerification.comment.by }}</v-row>
        <v-row>Text:</v-row>
        <v-card
          class="ma-1 pa-1" max-width="250px"
          elevation="1">
          {{ pendingVerification.comment.text }}
        </v-card>
        <v-row>Type:
          {{ pendingVerification.comment.type === 'candle' ? 'Kerze'
          : pendingVerification.comment.type === 'static' ? 'Unvergessen-Standart Kommentar'
          : pendingVerification.comment.type === 'memory' ? 'Erinnerung'
          : 'Traueranzeige' }}
        </v-row>
        <v-row>Bild: {{ pendingVerification.comment.image }}</v-row>
      </v-col>
    </v-container>

    <!-- Mockery Data -->
    <v-container class="pa-0" style="margin-left: 30px; margin-right: 30px">
      <v-col>
        <v-row
          ><h3><u>Mockery Detection</u></h3></v-row
        >
        <v-row>Tag:
          {{ pendingVerification.mockery.tag === 'p' ? 'ausstehend'
          : pendingVerification.mockery.tag === 'mu' ? 'vom Nutzer gemeldet'
          : pendingVerification.mockery.tag === 'mki' ? 'automatisch gemeldet'
          : pendingVerification.mockery.tag === 'd' ? 'für gut befunden'
          : 'gelöscht' }}
        </v-row>
        <v-row>Score: {{ pendingVerification.mockery.score }}</v-row>
        <v-row>Grund: {{ pendingVerification.mockery.reason }}</v-row>
      </v-col>
    </v-container>

    <v-spacer></v-spacer>

    <!-- Acction Buttons -->
    <v-card-actions>

      <!-- Go To Post button -->
      <v-container>
        <v-row>
          <v-col>
            <v-btn
              block
              color="orange"
              @click="goToPost(pendingVerification.candle.page_id)"
              >Seite ansehen</v-btn
            >
          </v-col>
        </v-row>
        <v-row>

          <!-- Deny button -->
          <v-col>
            <v-btn
              block
              color="red"
              @click="
                dialog = true;
                dialogText = 'Möchtest du den Kommentar wirklich löschen?';
                dialogStatus = false;
                greenBtnDialog = 'Löschen'
              "
              >Löschen</v-btn
            >
          </v-col>

          <!-- Accept Button -->
          <v-col>
            <v-btn
              block
              color="green"
              @click="
                dialog = true;
                dialogText = 'Möchtest du den Kommentar wirklich wiederherstellen?';
                dialogStatus = true;
                greenBtnDialog = 'Wiederherstellen'
              "
              >Wiederherstellen</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>

    <!-- Sure verification popup -->
    <v-dialog v-model="dialog" max-width="500">
      <v-card class="pa-4">
        <v-row class="pa-o ma-o">
          <v-col align="right" class="pa-0 ma-0">
            <v-icon @click="dialog = false" style="margin-right: 20px"> mdi-close</v-icon>
          </v-col>
        </v-row>

        <!-- Popup text -->
        <v-row>
          <v-card-text align="center">
            {{ dialogText }}
          </v-card-text>
        </v-row>
        <v-row>

          <!-- Popup deny button -->
          <v-col>
            <v-btn block color="red" @click="dialog = false">Abbrechen</v-btn>
          </v-col>

          <!-- Popup accept button -->
          <v-col>
            <v-btn
              block
              color="green"
              @click="
                postPendings(dialogStatus);
                dialog = false;
              "
            >
              {{greenBtnDialog}}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      urlPage: 'https://sandbox.eternio.de/Gedenkseite/',
      dialog: false,
      dialogText: 'asdf',
      dialogStatus: undefined,
      greenBtnDialog: ''
    }
  },
  props: ['pendingVerification'],
  methods: {
    postPendings (pendingStatus) {
      const vue = this
      axios
        .post('/verification/verify', {
          id: this.pendingVerification.id,
          status: pendingStatus
        })
        .then((res) => {
          vue.$emit('updatePendingsVerifications', res.data)
        })
    },
    goToPost (id) {
      window.open(this.urlPage + id)
    }
  }
}
</script>
<style scoped>
#pageList {
  list-style-type: none;
}

#pageList a {
  text-decoration: none;
  color: black;
}
</style>
